import React, { useContext, useEffect, useState } from "react";

import { DataContext } from "../../../../providers/ElectricityDataProvider";
import CalculatorHeader from "../../../shared/CalculatorHeader";
import CalculatorInactiveText from "../../../shared/CalculatorInactiveText";
import Container from "../../../shared/Container";
import CalculatorResult from "../../Electricity/CalculatorPage/CalculatorResult";
import Calculator from "./Calculator";
import Message from "./Message";

const CalculatorPage = ({ isActive = true, inactiveText = "" }) => {
    const [calculatorVisible, setCalculatorVisible] = useState(false);
    const dataContext = useContext(DataContext);
    const { result, validZipcode, maxConsumptionError, loading, validResult } =
        dataContext.data;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!loading) {
            if (validZipcode && !maxConsumptionError && validResult) {
                setCalculatorVisible(false);
            } else {
                setCalculatorVisible(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, result]);

    return isActive ? (
        <Container>
            <CalculatorHeader
                headline="Strom"
                hideChangeData={calculatorVisible}
                onClickChangeData={() => setCalculatorVisible(true)}
            />
            {calculatorVisible && <Calculator />}
            <Message />
            <CalculatorResult />
        </Container>
    ) : (
        inactiveText && (
            <CalculatorInactiveText>{inactiveText}</CalculatorInactiveText>
        )
    );
};

export default CalculatorPage;
